import { ProfileContainer } from "../../../containers/ProfileContainer"

export const Profile = () => <ProfileContainer />